<template>
  <section>
    <div
      class="wrapper-notification py-3 px-2 bg-muted mb-2"
      @click.stop="selectNotification(notification)"
      :class="{
        success: isSuccess(notification.title),
        rejected: isReject(notification.title),
      }"
      v-for="notification in localNotifications"
      :key="notification.id"
    >
      <div>
        <div class="wrapper-notification-description">
          <div v-if="getCoins(notification.coins)" class="bg-coin-medium small-icon coin">
            <span class="pt-1">{{ getCoins(notification.coins) }}</span>
          </div>
          <div v-else>
            <img :src="require('@/assets/modules-05.svg')" class="image-icon-style" alt="image" />
          </div>
          <span class="text-wrap d-block w-100">{{ notification.description }}</span>
        </div>
        <div class="wrapper-notification-success-rejected-icon">
          <div>
            <span v-if="existCreationDate(notification)" class="wrapper-notification-date ">
              <b>Creation date: </b> {{ formatLongDate(notification.action_object.date) }}
            </span>
          </div>
          <template
            v-if="!isParent && (isSuccess(notification.title) || isReject(notification.title))"
          >
            <span
              :class="
                isSuccess(notification.title) ? 'material-icons success' : 'material-icons rejected'
              "
              >{{ isSuccess(notification.title) ? 'done' : 'close' }}</span
            >
          </template>
        </div>
        <div class="wrapper-notification--actions">
          <div class="parent" v-if="isParent && notification.actions">
            <button class="action" @click.stop="acceptRejectEmit(notification, true)">
              <span class="material-icons success">done</span>
              <span class="small-icon success">accept</span>
            </button>
            <button class="action" @click.stop="acceptRejectEmit(notification, false)">
              <span class="material-icons rejected">close</span>
              <span class="small-icon success">reject</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { formatLongDate } from '@/common/utils/Date';

export default {
  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
    isParent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localNotifications: this.notifications,
      formatLongDate,
      closeOrDone: false,
    };
  },
  methods: {
    isSuccess(title = '') {
      return title.includes('approved') || title.includes('accept');
    },
    isReject(title = '') {
      return title.includes('reject');
    },
    getCoins(coins = {}) {
      const hasCoins = !!Object.keys(coins).length;
      return hasCoins ? coins['value'] : 0;
    },
    selectNotification(notification) {
      if (!notification.actions) {
        this.RemoveNotificationById(notification.id);
        this.$emit('onNotification', notification);
      }
    },
    acceptRejectEmit(notification, accept) {
      this.RemoveNotificationById(notification.id);
      this.$emit(accept ? 'onAccept' : 'onReject', notification);
    },
    RemoveNotificationById(id) {
      this.localNotifications = this.localNotifications.filter(
        (_notification) => _notification.id !== id,
      );
      this.$emit('allNotificationsHaveBeenViewed', !this.localNotifications.length);
    },
    existCreationDate(notification) {
      return notification?.action_object?.date ? true : false;
    },
  },
};
</script>

<style lang="scss">
:root {
  --success-notification: #5de192;
  --reject-notification: #ff5569;
}

.wrapper-notification {
  border-radius: 10px;
  display: flex;
  flex: auto;
  flex-direction: column;
  gap: 10px;

  &--actions {
    .parent {
      display: flex;
      gap: 100px;
      justify-content: center;
      border-top-color: rgba(152, 152, 152, 0.491);
      border-top-width: 1px;
      border-top-style: solid;
      margin-top: 8px;

      .action {
        border: 0;
        outline: none;
        background: transparent;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
      }

      .material-icons {
        &.success {
          color: var(--success-notification);
        }
        &.rejected {
          color: var(--reject-notification);
        }
      }
    }
  }

  &.success {
    background-color: var(--success-notification) !important;
    color: white;

    .wrapper-notification--actions {
      .material-icons {
        padding: 0.5rem;
        background-color: white;
        color: var(--success-notification) !important;
        border-radius: 10px;
      }
    }
  }

  &.rejected {
    background-color: var(--reject-notification) !important;
    color: white;

    .wrapper-notification--actions {
      .material-icons {
        padding: 0.5rem;
        background-color: white;
        color: var(--reject-notification) !important;
        border-radius: 10px;
      }
    }
  }
}
.wrapper-notification-description {
  display: flex;
  gap: 10px;
}
.wrapper-notification-success-rejected-icon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .material-icons {
    padding: 0.5rem;
    background-color: white;
    border-radius: 10px;
    &.success {
      color: var(--success-notification);
    }
    &.rejected {
      color: var(--reject-notification);
    }
  }
}
.wrapper-notification-date {
  color: #4242428c;
  font-size: 12px;
  margin-top: 8px;
  margin-left: 34px;
}
.coin {
  min-width: 25px;
  display: flex;
  justify-content: center;
}
.image-icon-style {
  height: 25px;
}
</style>
